<template>
    <div class="container py-5">
        <div class="d-flex flex-column">
            <h4 class="mb-0 fw-bold">{{ version?.title ?? '' }}</h4>
            <div class="text-muted small mb-20">{{ version?.revision_number ?? '' }}</div>
            <div id="consent-box"
                class="card mb-25 border-0 rounded-0 bg-white letter-spacing flex-grow-1 overflow-y-auto">
                <!-- <div class="d-flex justify-content-center h-100 align-items-center" v-if="consent_details === undefined">
                    <SpinnerLoading class="h-auto"/>
                </div> -->
                <div class="card-body p-15 p-sm-20 p-md-25 " v-html="version?.body"></div>
            </div>
            <div class="form-check form-group mb-15 mb-sm-20 mb-md-25" v-if="version?.has_checkbox ?? false">
                <input class="form-check-input shadow-none" type="checkbox" v-model="accept" id="accept">
                <label class="form-check-label fw-medium position-relative top-1" for="accept">
                    {{ version?.checkbox_disclaimer ?? '' }}
                </label>
            </div>
            <div class="text-end">
                <button :disabled="!nextEnabled" v-on:click="submitConsent"
                    class="default-btn transition fw-medium text-white pt-10 pb-10 ps-25 pe-25 pt-md-11 pb-md-11 ps-md-35 pe-md-35 fs-md-15 fs-lg-16">{{ $t('cta.next') }}</button>
            </div>
        </div>
    </div>
    <AlertModal id="cosnent_update" :title="$t('feature.$consents.update')"
        :message="$t('feature.$consents.update_message')" @close="alertModal?.hide()" />

</template>
<style lang="scss">
#consent-box {
    h3 {
        font-size: 16px;
    }
    h4 {
        font-size: 14px;
        color: #000!important;
    }
    table {
        margin-bottom: 1rem;
        
        th, td {
            border: 1px solid #606060;
            padding: .25rem .5rem;
        }
        tr {
            vertical-align: baseline;
        }
        p {
            margin-bottom: 0;
        }
    }
}
</style>

<script lang="ts">
import AlertModal from '@/components/Widgets/AlertModal.vue';
import API from '@/services/api/api.service';
import { Consent, ConsentVersion } from '@/utils/models/consent.model';
import { Modal } from 'bootstrap';
import { defineComponent } from 'vue';

export default defineComponent({
    name: "ConsentGrantPage",
    components: {
        AlertModal
    },
    mounted() {
        /* this.getConsents().finally(() => {
            this.addScrollListener();
        }); */
        document.body.classList.add("bg-body-secondary");
        this.addScrollListener();
        this.alertModal = new Modal('#cosnent_update', {});
        this.alertModal?.show();
    },
    unmounted() {
        document.body.classList.remove("bg-body-secondary");
        this.removeScrollListener();
    },

    data() {
        return {
            index: 0,
            consents: this.$route.meta.consents as Consent[],
            // consent_details: undefined as Consent[] | undefined,
            accept: false,
            scrolled_bottom: false,
            consent_box: undefined as HTMLElement | undefined,
            alertModal: undefined as Modal | undefined,
        }
    },

    computed: {
        version(): ConsentVersion | undefined { return this.consents[this.index].current_version },
        accepted(): boolean { return ((this.version?.has_checkbox ?? false) && (this.version?.mandatory ?? false)) ? this.accept : true },
        nextEnabled(): boolean { return (this.version?.text_scroll ?? false) ? this.accepted && this.scrolled_bottom : true },
    },
    methods: {
        /* async getConsents() {
            return Promise.all(this.consents!.map((consent) => API.getConsent(consent.id!))).then((responses) => {
                this.consent_details = (responses?.map((res) => res.data.data) ?? []).flat();
            })
        }, */
        removeScrollListener() {
            if (this.consent_box !== undefined && this.consent_box !== null) {
                console.log('remove_scroll_listener');
                this.consent_box.removeEventListener('scroll', this.checkScroll);
            }
        },
        addScrollListener() {
            setTimeout(() => {
                this.scrolled_bottom = false;
                this.consent_box = document.getElementById('consent-box')!;
                this.consent_box.scrollTop = 0;
                console.log('add_scroll_listener');
                this.consent_box.addEventListener('scroll', this.checkScroll);
                this.checkScroll(null);
            }, 10)
        },
        checkScroll(event) {
            if (this.consent_box !== undefined && (Math.ceil(this.consent_box!.scrollTop + this.consent_box!.offsetHeight) >= this.consent_box!.scrollHeight)) {
                console.log('scrolled_bottom');
                this.scrolled_bottom = true;
                this.removeScrollListener();
            }
        },
        nextConsent() {
            this.index++;
            this.accept = false;
            this.removeScrollListener();
            this.addScrollListener();
        },
        submitConsent() {
            API.registerUserConsent({
                version_id: this.version?.id!,
                action: this.accepted == true ? 'accept' : 'deny',
            }).then((res) => {
                if (res.data.success === true) {
                    if (this.index === this.consents.length - 1) {
                        this.$router.push('/');
                    } else {
                        this.nextConsent();
                    }
                }
            }).catch((error) => {
                console.error('REGISTER_CONSENT_ERROR')
            })

        }
    }
});
</script>